import React from "react";

import { QuestionnairePageType } from "@common/dto/questionnaire/page/type";
import { QuestionnaireConsentTabCreateDto, QuestionnaireConsentTabUpdateDto } from "@common/dto/questionnaire/consent-tab";

import { ConsentProps } from "./consent.types";

export const useConsentController = (props: ConsentProps) => {
  const {
    onChange,
    questionnaire,
  } = props;

  const currentEditingPage = React.useMemo(() => {
    return {
      ...questionnaire.consentTab,
      enabled: questionnaire.homeTab?.showConsent ?? questionnaire.consentTab.page?.enabled ?? false,
    };
  }, [questionnaire.consentTab]);

    const handleFieldChange = React.useCallback((params: Partial<QuestionnaireConsentTabUpdateDto> | Partial<QuestionnaireConsentTabCreateDto>) => {
    const nextPage = params?.page
      ? {
          ...questionnaire.consentTab.page,
          ...params.page,
          pageType: QuestionnairePageType.consent,
        }
      : questionnaire.consentTab.page;

    onChange({
      ...questionnaire,
      homeTab: {
        ...questionnaire.homeTab,
        showConsent: nextPage?.enabled ?? questionnaire.consentTab.page?.enabled ?? false,
      },
      consentTab: {
        ...questionnaire.consentTab,
        ...params,
        page: nextPage,
      },
    });
  }, [onChange, questionnaire]);

  return {
    currentEditingPage,
    handleFieldChange
  };
};
